import logo from "./logo.svg";
import "./App.css";
import { BrowserRouter } from "react-router-dom";
import { LoaderProvider } from "./utils/LoaderUtils";
import ScrollToTop from "./utils/ScrollToTopUtils";
import { ToastContainer } from "react-toastify";
import { SiteConfigProvider } from "./context/SiteConfigContext";
import PageLoader from "./context/PageLoader";
import { Suspense } from "react";
import AnimatedRoutes from "./Components/AnimatedRoutes";

function App() {
  return (
    <>
      <SiteConfigProvider>
        <LoaderProvider>
          <BrowserRouter >
            <ScrollToTop />
            <Suspense fallback={<PageLoader />}>
              <AnimatedRoutes />
            </Suspense>
          </BrowserRouter>
        </LoaderProvider>
      </SiteConfigProvider>

      <ToastContainer position="top-right" autoClose={3000} />
    </>
  );
}

export default App;